import React from "react";
import { Navigate } from "react-router-dom";
import { useDriverAuth } from "../../context/DriverAuthContext";

export default function DriverRouteGuard({ children }) {
  const { driver, token, loading } = useDriverAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex", alignItems: "center",
        justifyContent: "center", background: "#003566"
      }}>
        <div style={{ color: "#FFD60A", fontFamily: "serif", fontSize: "1.2rem" }}>
          Loading…
        </div>
      </div>
    );
  }

  if (!token || !driver || driver.role !== "driver") {
    return <Navigate to="/driver/login" replace />;
  }

  return children;
}